import React from 'react';
import { PageLayout } from '../components/PageLayout';
import { PartySizeGrid } from '../components/PartySizeGrid';
import { PrimaryButton } from '../components/PrimaryButton';
import { useLanguage } from '../i18n/LanguageContext';
import styles from './PartySizePage.module.css';

interface PartySizePageProps {
  partySize: number;
  isSubmitting: boolean;
  error: string | null;
  onSelect: (size: number) => void;
  onSubmit: () => void;
  takeoutEnabled?: boolean;
  waitingCount?: number;
  estimatedMinutes?: number;
  takeoutWaitingCount?: number;
  takeoutEstimatedMinutes?: number;
  storeImage?: string | null;
}

/**
 * 인원수 선택 페이지
 * - 인원수 그리드, 등록하기 버튼, 에러 메시지
 */
export function PartySizePage({
  partySize,
  isSubmitting,
  error,
  onSelect,
  onSubmit,
  takeoutEnabled = false,
  waitingCount = 0,
  estimatedMinutes = 0,
  takeoutWaitingCount = 0,
  takeoutEstimatedMinutes = 0,
  storeImage = null,
}: PartySizePageProps) {
  const { t } = useLanguage();
  const canSubmit = partySize > 0 && !isSubmitting;

  return (
    <PageLayout
      title={t('party_title')}
      takeoutEnabled={takeoutEnabled}
      waitingCount={waitingCount}
      estimatedMinutes={estimatedMinutes}
      takeoutWaitingCount={takeoutWaitingCount}
      takeoutEstimatedMinutes={takeoutEstimatedMinutes}
      storeImage={storeImage}
      footer={
        <div className={styles.buttonWrapper}>
          <PrimaryButton onClick={onSubmit} disabled={!canSubmit}>
            {isSubmitting ? (
              <span className={styles.loadingText}>{t('party_submitting')}</span>
            ) : (
              t('party_submit')
            )}
          </PrimaryButton>
        </div>
      }
    >
      <div className={styles.content}>
        <PartySizeGrid selectedSize={partySize} onSelect={onSelect} />
        {error && <p className={styles.errorMessage}>{error}</p>}
      </div>
    </PageLayout>
  );
}
